import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import RoomIcon from '@mui/icons-material/Room';
import WidgetsIcon from '@mui/icons-material/Widgets';
import TouchAppIcon from '@mui/icons-material/TouchApp';

export const TriggerAreaCard = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: 16,
  borderRadius: 8,
  backgroundColor: 'var(--am-accent-surface)',
  border: '1px solid var(--am-border)',
  marginBottom: 16,
});

export const TriggerAreaCardLabel = styled(Typography)({
  fontSize: '12px',
  color: 'var(--am-text-secondary)',
  lineHeight: 1.2,
}) as typeof Typography;

export const TriggerAreaCardTitle = styled(Typography)({
  fontWeight: 700,
  color: 'var(--am-accent-text)',
  fontSize: '15px',
  marginTop: 4,
}) as typeof Typography;

export const TriggerAreaCardPinIcon = styled(RoomIcon)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: 20,
  flexShrink: 0,
}));

export const TriggerAreaCardObjectIcon = styled(WidgetsIcon)({
  color: 'var(--am-icon-accent)',
  fontSize: 20,
  flexShrink: 0,
});

export const TriggerTogglePinIcon = styled(RoomIcon)(({ theme }) => ({
  fontSize: 15,
  marginRight: 6,
  color: theme.palette.error.main,
}));

export const TriggerToggleTouchIcon = styled(TouchAppIcon)(({ theme }) => ({
  fontSize: 15,
  marginRight: 6,
  color: theme.palette.warning.main,
}));

export const TriggerInfoBox = styled(Box)(({ theme }) => ({
  padding: 12,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: 'var(--am-surface)',
  border: '1px solid var(--am-border)',
}));

export const UiClickSectionLabel = styled(Typography)({
  fontSize: '11px',
  fontWeight: 700,
  letterSpacing: '0.07em',
  textTransform: 'uppercase',
  color: 'var(--am-label-color)',
  marginBottom: 6,
}) as typeof Typography;

export const AllowSkipBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: 16,
  borderRadius: 8,
  border: '1px solid var(--am-border)',
  backgroundColor: 'var(--am-surface)',
});

export const AllowSkipTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: 1.3,
  color: 'var(--am-text-primary)',
}) as typeof Typography;

export const AllowSkipDescription = styled(Typography)({
  fontSize: '13px',
  color: 'var(--am-text-secondary)',
  lineHeight: 1.3,
}) as typeof Typography;
